import { render, staticRenderFns } from "./ProvidersIndex.vue?vue&type=template&id=08ea67b8&scoped=true&"
import script from "./ProvidersIndex.vue?vue&type=script&lang=js&"
export * from "./ProvidersIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersIndex.vue?vue&type=style&index=0&id=08ea67b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea67b8",
  null
  
)

export default component.exports